export default function mobileNavInit() {
    // Closes modal when link is clicked -- same page
    // $(".nav-item a").click(function () {
    //     $("#navigationModal").modal("hide");
    //     if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
    //         var target = $(this.hash);
    //         target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    //         if (target.length) {
    //             $("html, body").animate(
    //                 {
    //                     scrollTop: target.offset().top - 50,
    //                 },
    //                 0
    //             );
    //             return false;
    //         }
    //     }
    // });
    const anchorLinks = document.querySelectorAll(".anchor-link");
    const closeButton = document.querySelector(".close");

    // Delay closing menu until page has scrolled to anchor link
    function closeOffcanvas() {
        setTimeout(() => {
            closeButton.click();
        }, 400);
    }

    // Conditionally add/remove eventListener based on mobile/desktop view
    function setupListeners() {
        if (window.innerWidth < 1200) {
            anchorLinks.forEach((link) => {
                link.removeEventListener("click", closeOffcanvas); // Prevent duplicate bindings
                link.addEventListener("click", closeOffcanvas);
            });
        } else {
            anchorLinks.forEach((link) => {
                link.removeEventListener("click", closeOffcanvas);
            });
        }
    }

    // Run on function call
    setupListeners();

    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setupListeners, 100); // Debounced execution
    });
}
